import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import ProductionList from './lists/ProductionList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import ProductionForm from "./forms/ProductionForm";
import Button from "../form/Button";

class ProductionEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
        this.editor && this.editor.hide();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        return (
            <Fragment>
                <List
                    {...this.props}
                    key={1}
                    theme="default"
                    header="Gyártások"
                    footer={[
                        <Button key="0" disabled={this.props.isLoading} color="default" onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <ProductionList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    key={2}
                    theme="default"
                    header="Gyártás"
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>
                    ]}
                >
                    <ProductionForm {...this.props} />
                </Editor>
                <Other>

                </Other>
            </Fragment>
        );
    }
}

export default createEditor({
    componentName: "Production",
    WrappedComponent: ProductionEditor,
    props: {
        view: "admin",
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            return {action, data, params};
        }
    }
});